class EntitlerService {
  constructor(config, httpDim) {
    this.config = config;
    this.httpDim = httpDim;
  }

  fetchCoursesByProduct(productId,offset,sortBy,limit,searchValue){
    let config = this.config;
    let url = `${this.config.apiRoot}/product/${productId}/courses?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchProductsByCustomer({
    limit,
    offset,
    sortBy,
    searchValue,
    purchasingAccountNumber,
    licensingType,
  }) {
    let config = this.config;
    const manageLicenses = licensingType && licensingType.toLowerCase() === 'directlicensing' || false;
    let url = `${this.config.apiRoot}/products?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}${purchasingAccountNumber? `&purchasingAccountNumber=${purchasingAccountNumber}` : ''}&manageLicenses=${manageLicenses}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchResourcesByProduct({
    limit,
    offset,
    sortBy,
    productId,
    searchValue,
    purchasingAccountNumber
  }) {
    let config = this.config;
    let url = `${this.config.apiRoot}/products/${productId}/resources?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}${purchasingAccountNumber? `&purchasingAccountNumber=${purchasingAccountNumber}` : ''}`;
    let methodHasToShowContentLoader = true;
    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchALEKSMasterTemplatesByProduct({
    limit,
    offset,
    // sortBy,
    productId,
    searchValue,
  }) {
    let config = this.config;
    let url = `${this.config.apiRoot}/products/${productId}/aleks-master-templates?offset=${offset}&limit=${limit}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;
    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchAssignedProductsByCustomer(offset,sortBy,limit,searchValue){
    let config = this.config;
    let url = `${this.config.apiRoot}/assignedProducts?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchCoursesByCourseIds(courseIds,offset,sortBy,limit,searchValue){
    let config = this.config;
    let url = `${this.config.apiRoot}/courses/${JSON.stringify(courseIds)}?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchClassesByClassIds(classIds,offset,sortBy,limit,searchValue){
    let config = this.config;
    let url = `${this.config.apiRoot}/classes/${JSON.stringify(classIds)}?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchCourseIdsByProduct(productId) {
    let config = this.config;
    let url = `${this.config.apiRoot}/product/${productId}/courseIds`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchDataByCustomer(offset, uri, sortBy, limit, searchValue, productAssignmentId, enterpriseResourceId, aleksMasterTemplateId, isSecondaryProduct = false, isConnectEdProduct = false, manageLicenses=false) {
    let config = this.config;
    let url = `${this.config.apiRoot}/${uri}?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}&productAssignmentId=${productAssignmentId}&enterpriseResourceId=${enterpriseResourceId}&aleksMasterTemplateId=${aleksMasterTemplateId}&isSecondaryProduct=${isSecondaryProduct}&isConnectEdProduct=${isConnectEdProduct}&manageLicenses=${manageLicenses}&skipCount=true`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchClassesByProduct(productId,offset,sortBy,limit,searchValue){
    let config = this.config;
    let url = `${this.config.apiRoot}/product/${productId}/classes?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchClassesBySchoolIds(schoolIds,offset,sortBy,limit,searchValue){
    let config = this.config;
    let url = `${this.config.apiRoot}/schools/${JSON.stringify(schoolIds)}/classes?offset=${offset}&limit=${limit}&sortColumn=${sortBy.column}&sortOrder=${sortBy.order}&searchValue=${searchValue}`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  fetchClassIdsByProduct(productId) {
    let config = this.config;
    let url = `${this.config.apiRoot}/product/${productId}/classIds`;
    let methodHasToShowContentLoader = true;

    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  lastWorkflowForProductAssignment(selectedProduct) {//PR 1075 deploying changes to qastg
    let idOrAleksMasterTemplateId;

    if(selectedProduct.id){
      idOrAleksMasterTemplateId = selectedProduct.id;
    } else {
      idOrAleksMasterTemplateId = selectedProduct.aleksMasterTemplateId;
    }
    let url = this.config.apiRoot + `/products/${ idOrAleksMasterTemplateId }/last/workflow`;
    return this.httpDim.get(url, {});
  }

  importProducts() {
    let url = `${this.config.apiRoot}/importProducts`;
    return this.httpDim.post(url, {
      status: "NEW",
      customerAction: "IMPORT_PRODUCTS",
    });
  }

  updateProductsAssociations ({
    type,
    assign,
    unassign,
    assignSchools,
    unassignSchools,
    assignAllSchools,
    unassignAllSchools,
    productAssignmentId,
    aleksMasterTemplateId,
    enterpriseResourceId,
    manageLicenses
  }) {
    let url = `${this.config.apiRoot}/products?manageLicenses=${manageLicenses}`;
    const assignment = {
      productAssignmentId
    };
    if (enterpriseResourceId) {
      assignment.enterpriseResourceId = enterpriseResourceId;
    }
    if (aleksMasterTemplateId) {
      assignment.aleksMasterTemplateId = aleksMasterTemplateId;
    }
    return this.httpDim.post(url, {
      type,
      assign,
      unassign,
      assignSchools,
      unassignSchools,
      assignAllSchools,
      unassignAllSchools,
      productAssignments: [assignment]
    });
  }

  unAssignProductEnrollments(classesToNotDelete, coursesToNotDelete, productIds) {
    let config = this.config;
    let url = `${this.config.apiRoot}/products?&classesToNotDelete=${JSON.stringify(classesToNotDelete)}`;
    url += `&coursesToNotDelete=${JSON.stringify(coursesToNotDelete)}&productIds=${JSON.stringify(productIds)}`;

    return this.httpDim.delete(url, config);
  }

  recommendProductEdition(product) {
    let url = `${this.config.apiRoot}/products/${product.id}/recommendations`;
    return this.httpDim.get(url, this.config);
  }

  getOrgsByType(customerId, type) {
    const url = `${this.config.apiRoot}/organizations?customerId=${customerId}&type=${type}`;
    return this.httpDim.get(url, {});
  }

}

EntitlerService.$inject = ['config', 'httpDim'];

export
default EntitlerService;



// WEBPACK FOOTER //
// ./app/common/entitlerService/entitlerService.service.js